import { Env } from '@didi/utils'
import { noop, getContent } from '../util/tool'
import { wechatReady } from '../core/wechat'
import { mqqReady } from '../core/mqq'
import { didiSDKReady } from '../core/didi'
import { alipayReady } from '../core/alipay'
import commonLangZh from '../lang/zh-CN/common'
import commonLangEn from '../lang/en-US/common'
import shareLangZh from '../lang/zh-CN/set-share'
import shareLangEn from '../lang/en-US/set-share'

const allContent = {
  'zh-CN': {
    ...commonLangZh,
    ...shareLangZh
  },
  'en-US': {
    ...commonLangEn,
    ...shareLangEn
  }
}
let lang

const SHARE_SUCCESS_MSG = 'share success'
const SHARE_CANCEL_MSG = 'share cancel'
const SHARE_DISABLED_MSG = 'share disabled'
const SHARE_FROM_WECHAT = 'wechat'
const SHARE_FROM_ALI = 'alipay'
const SHARE_FROM_MQQ = 'mqq'

const SHARE_TO_WECHAT_TIMELINE = 'wechat timeline'
const SHARE_TO_WECHAT_CONTACT = 'wechat contact'
const SHARE_TO_MQQ_TIMELINE = 'mqq timeline'
const SHARE_TO_MQQ_CONTACT = 'mqq contact'
const SHARE_TO_ALI_TIMELINE = 'alipay timeline'
const SHARE_TO_ALI_CONTACT = 'alipay contact'
const mqqShareTypeHash = {
  0: SHARE_TO_MQQ_CONTACT,
  1: SHARE_TO_MQQ_TIMELINE,
  2: SHARE_TO_WECHAT_CONTACT,
  3: SHARE_TO_WECHAT_TIMELINE
}
const alipayShareTypeHash = {
  ALPContact: SHARE_TO_ALI_CONTACT,
  ALPTimeLine: SHARE_TO_ALI_TIMELINE,
  Weibo: 'Weibo',
  SMS: 'SMS'
}
/**
 * 设置分享
 * @param conf
 * conf.title 分享标题
 * conf.imageUrl 分享图片url
 * conf.shareUrl 分享的链接
 * conf.desc 分享描述
 */
export function setShare (conf, callback = noop) {
   /* istanbul ignore else */
  if (conf && conf.lang) {
    lang = conf.lang
  }
	if (Env.isWechat) {
		shareWechat(conf, callback)
	} else if (Env.isAlipay && conf.alipayShareAble) {
    shareAlipay(conf, callback)
	} else if (Env.isMqq) {
		shareMqq(conf, callback)
	} else if (Env.isPassenger) {
    sharePassenger(conf, callback)
  } else {
		callback(new Error(getContent(allContent, 'noSupport', lang)))
	}
}

export default setShare

const wechatDefaultChannel = ['WechatTimeLine', 'WechatContact', 'QQContact', 'QQZone']
const wechatChannelMap = {
  WechatTimeLine: 'menuItem:share:timeline',
  WechatContact: 'menuItem:share:appMessage',
  QQContact: 'menuItem:share:qq',
  QQZone: 'menuItem:share:QZone'
}
function getWechatDisableChannel(enableChannel) {
  if (!enableChannel) {
    return []
  }
  const disChannel = []
  wechatDefaultChannel.forEach(key => {
    if (enableChannel.indexOf(key) < 0) {
      disChannel.push(wechatChannelMap[key])
    }
  })
  return disChannel
}
function wechatHideChannel(wx, channels) {
  wx.hideMenuItems({
    menuList: channels
  })
}

function shareWechat(conf, callback) {
	wechatReady((err, wx) => {
		if (!err) {
       /* istanbul ignore else */
      if (!conf) {
        return
      }
      if (conf.disabled) {
        wx.hideAllNonBaseMenuItem()
        callback(null, {
          msg: SHARE_DISABLED_MSG
        })
        return
      }
      wx.showAllNonBaseMenuItem()
      const channels = getWechatDisableChannel(conf.wechatChannel)
      if (channels.length > 0) {
        wechatHideChannel(wx, channels)
      }
			wx.onMenuShareTimeline({
				title: conf.desc, // 分享标题
				link: conf.shareUrl || conf.link, // 分享链接
				imgUrl: conf.imgUrl, // 分享图标
				success() {
					callback(null, {
            from: SHARE_FROM_WECHAT,
            to: SHARE_TO_WECHAT_TIMELINE,
            shared: true,
            msg: SHARE_SUCCESS_MSG
          })
				},
				cancel() {
					callback(null, {
            from: SHARE_FROM_WECHAT,
            to: SHARE_TO_WECHAT_TIMELINE,
            shared: false,
            msg: SHARE_CANCEL_MSG
          })
				}
			})

			wx.onMenuShareAppMessage({
				title: conf.title, // 分享标题
				desc: conf.desc, // 分享描述
				link: conf.shareUrl || conf.link, // 分享链接
				imgUrl: conf.imgUrl, // 分享图标
				success: function () {
					callback(err, {
            from: SHARE_FROM_WECHAT,
            to: SHARE_TO_WECHAT_CONTACT,
						shared: true,
						msg: SHARE_SUCCESS_MSG
					})
				},
				cancel: function () {
					callback(err, {
            from: SHARE_FROM_WECHAT,
            to: SHARE_TO_WECHAT_CONTACT,
						shared: false,
						msg: SHARE_CANCEL_MSG
					})
				}
			})
		} else {
			callback(err)
		}
	})
}

function shareMqq(conf, callback) {
	mqqReady((err, mqq) => {
		if (!err) {
      if (conf.disabled) {
        mqq.ui.setTitleButtons({
          right: {
            hidden: true
          }
        })
        callback(null, {
          msg: SHARE_DISABLED_MSG
        })
        return
      }
			mqq.ui.setOnShareHandler((type) => {
				mqq.ui.shareMessage({
					title: conf.title,
					desc: conf.desc,
					share_url: conf.shareUrl || conf.link,
					image_url: conf.imgUrl,
					share_type: type,
					back: true
				}, (result) => {
					if (result.retCode === 0) {
						callback(err, {
              from: SHARE_FROM_MQQ,
              to: mqqShareTypeHash[type],
							shared: true,
							msg: SHARE_SUCCESS_MSG
						})
					} else {
						callback(err, {
              from: SHARE_FROM_MQQ,
              to: mqqShareTypeHash[type],
							shared: false,
							msg: SHARE_CANCEL_MSG
						})
					}
				})
			})
		} else {
			callback(err)
		}
	})
}

const alipayDefaultChannel = ['ALPContact', 'ALPTimeLine', 'Weibo', 'SMS']

function shareAlipay(conf, callback) {
   /* istanbul ignore else */
  if (!conf.shareUrl && !conf.link) {
    conf.shareUrl = window.location.href
  }

  alipayReady((err, alipay) => {
    if (err) {
      callback(err)
      return
    }

    if (!alipay) {
      callback(new Error(getContent(allContent, 'alipayBridgeError', lang)))
      return
    }
    if (conf.disabled) {
      alipay.call('hideOptionMenu')
      callback(null, {
        msg: SHARE_DISABLED_MSG
      })
      return
    }
    const channels = conf.alipayChannel ? conf.alipayChannel : alipayDefaultChannel
    // 自定义右上角按钮
    alipay.call('setOptionMenu', {title: '分享'})
    // 显示右上角按钮
    alipay.call('showOptionMenu')
    // 监听右上角按钮点击事件
    document.addEventListener('optionMenu', function () {
      // 开始做自定义分享
      alipay.call('startShare', {
        'bizType': '2015042700050887_P2P',
        'onlySelectChannel': channels
      }, function (selectData) {
        if (channels.indexOf(selectData.channelName) !== -1) {
          switch (selectData.channelName) {
            case 'ALPContact':
              var param = {
                contentType: 'url',
                title: conf.title,
                content: conf.desc,
                iconUrl: conf.imgUrl,
                url: conf.shareUrl || conf.link
              }
              break
            case 'ALPTimeLine':
              param = {
                contentType: 'url',
                title: conf.title,
                iconUrl: conf.imgUrl,
                url: conf.shareUrl || conf.link
              }
              break
            case 'Weibo':
              param = {
                title: conf.title,
                content: conf.desc,
                imageUrl: conf.imgUrl,
                url: conf.shareUrl || conf.link
              }
              break
            case 'SMS':
              param = {
                content: conf.desc + '\n' + (conf.shareUrl || conf.link)
              }
              break
          }

          alipay.call('shareToChannel', {
            name: selectData.channelName,
            param: param
          }, function (shareData) {
            if (shareData.shareResult) {
              callback(err, {
                from: SHARE_FROM_ALI,
                to: alipayShareTypeHash[selectData.channelName],
                shared: true,
                status: 'success',
                ret: shareData,
                msg: SHARE_SUCCESS_MSG
              })
            } else {
              callback(err, {
                from: SHARE_FROM_ALI,
                to: alipayShareTypeHash[selectData.channelName],
                shared: false,
                status: 'fail',
                ret: shareData,
                msg: SHARE_CANCEL_MSG
              })
            }
          })
        }
      })
    })
  })
}

const passengerDefaultChannel = ['ALPContact', 'ALPTimeLine', 'WechatTimeLine', 'WechatContact', 'QQContact', 'QQZone', 'refreshPage']

const channelConf = {
  WechatTimeLine: {
    type: 'shareWeixinTimeline',
    name: '微信朋友圈'
  },
  WechatContact: {
    type: 'shareWeixinAppmsg',
    name: '微信好友'
  },
  ALPContact: {
    type: 'shareAlipayFriend',
    name: '支付宝好友'
  },
  ALPTimeLine: {
    type: 'shareAlipayLife',
    name: '支付宝生活圈'
  },
  QQContact: {
    type: 'shareQqAppmsg',
    name: 'qq好友'
  },
  QQZone: {
    type: 'shareQzone',
    name: 'qq空间'
  },
  refreshPage: {
    type: 'refreshPage',
    name: '刷新'
  }
}

function sharePassenger(conf, callback) {
  didiSDKReady((err, bridge) => {
    if (!err) {
      if (conf.disabled) {
        bridge.call('hideEntrance', {}, function (err, ret) {
          if (!err) {
            callback(null, {
              msg: SHARE_DISABLED_MSG
            })
          } else {
            callback(err)
          }
        })
        return
      }
      nativeShare(bridge, conf, callback)
    }
  })
}

function nativeShare(bridge, conf, callback) {
  if (!conf.shareUrl && !conf.link) {
    conf.shareUrl = window.location.href
  }
  const shareData = {
    url: conf.shareUrl,
    title: conf.title,
    content: conf.desc,
    icon: conf.imgUrl
  }
  const shareChannel = conf.passengerChannel ? conf.passengerChannel : passengerDefaultChannel
  const shareOpt = []
  for (let i = 0, len = shareChannel.length; i < len; i++) {
    shareOpt.push({
      ...channelConf[shareChannel[i]],
      data: shareData
    })
  }
  bridge.call('showEntrance', {
    buttons: shareOpt,
    windowCallBack: '__showEntranceCallBack__'
  })
  callback(null, {})
}
